// `shortlist.view-transition.service.ng1.ts` — the half of the view transition that lives in
// the PAGE.
//
// Upstream runs this on every `$stateChangeSuccess` under the extension or auth trees. The
// mechanics reduce to less than they look: `getDisplayedViewsFromState` returns `[Flex]` when
// any state in the chain declares a numeric `viewWidth` and `[]` when none does, so the Slim
// and Full branches of `onStateChange` are unreachable in practice and every real transition
// is `FlexMode` at `getMaxViewWidth(state)`. That is what this sends.
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { IFrameEventType, ViewMode, iframeClient, isInIFrame } from '@woo-ext/protocol'
import { maxViewWidthFor } from './viewWidth.ts'

export function useViewTransition(): void {
  const { pathname } = useLocation()

  useEffect(() => {
    // ⚠️ ONLY FROM INSIDE THE FRAME. A standalone SPA tab has no panel to resize and no
    // parent listening; posting anyway would be a message to the tab's own opener.
    if (!isInIFrame()) return

    const width = maxViewWidthFor(pathname)
    // "Declares nothing" is a real answer — upstream returns early rather than defaulting,
    // which is what leaves the panel as the user last sized it on a screen with no opinion.
    if (width === undefined) return

    iframeClient().send(IFrameEventType.SetViewModeStarted, {
      mode: ViewMode.FlexMode,
      extensionViewWidth: width,
    })
  }, [pathname])
}
